import { observer } from 'mobx-react';
import { Component } from 'react';

import { Button, Col, Row } from 'antd';
import FormLegendCentered from 'components/Forms/FormLegendCentered';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';
import WorkOrderLineItemDetails from './WorkOrderLineItemDetails';

import { WorkOrderLineItemProvider } from './WorkOrderLineItemContext';
import { PlusCircleOutlined } from '@ant-design/icons';

class WorkOrderLineItems extends Component {
  static contextType = WorkOrderDetailsContext;

  static propTypes = {};

  workOrderLinesDetailsRefs = {};

  get currentLineItems() {
    const {
      state: { lineItems },
    } = this.context;
    return lineItems;
  }

  render() {
    const {
      updateLineItemHeader,
      onChangeLineItemField,
      onAddNewPart,
      onUpdateLaborItem,
      onUpdatePartItem,
      onUpdateMiscellaneousItem,
      onUpdateDefectItem,
      onUpdateServiceItem,
      onRemoveLineItem,
      onSelectSystemCode,
      onSelectAsmCode,
      onAddLineItem,
      shopUsers,
      shopParts,
      shopVendors,
      currentCarIssues,
      onAddLabor,
      onAddPart,
      onAddIssue,
      onAddMiscellaneous,
      onAddDefect,
      onRemoveMiscellaneous,
      onRemoveDefect,
      onRemoveLabor,
      onRemovePart,
      onRemoveIssue,
      isDisabled,
      state: { screenSize, assetDefects, loadingAssetDefects },
    } = this.context;

    const onUserAction = () => {
      console.info('user action...');
      if (this.context.handleFormChange) {
        this.context.handleFormChange();
      }
    };

    return (
      <Row gutter={[8, 8]}>
        <Col span={24}>
          {this.currentLineItems.map((lineItem) => {
            return (
              <div key={lineItem.key}>
                <WorkOrderLineItemProvider
                  value={{
                    lineItem,
                    shopUsers,
                    shopParts,
                    shopVendors,
                    currentCarIssues,
                    onAddLabor,
                    onAddPart,
                    onAddIssue,
                    onAddMiscellaneous,
                    onAddDefect,
                    onRemoveMiscellaneous,
                    onRemoveDefect,
                    onRemoveLabor,
                    onRemovePart,
                    onRemoveIssue,
                    isDisabled,
                    screenSize,
                    assetDefects,
                    loadingAssetDefects,
                  }}
                >
                  <WorkOrderLineItemDetails
                    childRef={(ref) =>
                      (this.workOrderLinesDetailsRefs[lineItem.key] = ref)
                    }
                    onChangeServiceTask={(e, value) => {
                      onUserAction();
                      updateLineItemHeader(e, value, lineItem);
                    }}
                    onChangeField={(newVal, fieldName) => {
                      onUserAction();
                      onChangeLineItemField(lineItem.key, newVal, fieldName);
                    }}
                    onAddNewPart={(name) => {
                      onUserAction();
                      onAddNewPart(name || '', lineItem.key);
                    }}
                    onUpdateLaborItem={(labourKey, newVal, whatChanged) => {
                      onUserAction();
                      onUpdateLaborItem(
                        lineItem.key,
                        labourKey,
                        newVal,
                        whatChanged
                      );
                    }}
                    onUpdatePartItem={(partKey, newVal, changedField) => {
                      onUserAction();
                      onUpdatePartItem(
                        lineItem.key,
                        partKey,
                        newVal,
                        changedField
                      );
                    }}
                    onUpdateMiscellaneousItem={(
                      miscKey,
                      newVal,
                      changedField
                    ) => {
                      onUserAction();
                      onUpdateMiscellaneousItem(
                        lineItem.key,
                        miscKey,
                        newVal,
                        changedField
                      );
                    }}
                    onUpdateDefectItem={(defectKey, newVal, changedField) => {
                      onUserAction();
                      onUpdateDefectItem(
                        lineItem.key,
                        defectKey,
                        newVal,
                        changedField
                      );
                    }}
                    onUpdateServiceItem={(serviceKey, newVal) => {
                      onUserAction();
                      onUpdateServiceItem(lineItem.key, serviceKey, newVal);
                    }}
                    onRemoveLineItem={() => {
                      onUserAction();
                      onRemoveLineItem(lineItem.key);
                    }}
                    onSelectSystemCode={(systemCode) => {
                      onUserAction();
                      onSelectSystemCode(lineItem.key, systemCode);
                    }}
                    onSelectAsmCode={(asmCode) => {
                      onUserAction();
                      onSelectAsmCode(lineItem.key, asmCode);
                    }}
                  />
                </WorkOrderLineItemProvider>
              </div>
            );
          })}
        </Col>
        <Col span={24}>
          <FormLegendCentered>
            <Button
              type="primary"
              ghost
              onClick={() => {
                onUserAction();
                onAddLineItem();
              }}
              icon={<PlusCircleOutlined />}
            >
              Add New Service Task
            </Button>
          </FormLegendCentered>
        </Col>
      </Row>
    );
  }
}

export default observer(WorkOrderLineItems);
